<header *ngIf="!isHideHeader" class="layout-topbar">
  <a class="logo" routerLink="" *ngIf="logoUrl">
    <img [src]="logoUrl" alt="UC Davis Health" />
  </a>

  <h1 class="app-title">HS Forms</h1>

  <div class="topbar-navigation">
    <div class="user-info">
      <div class="user-name p-d-block">
        <i class="pi pi-user" (click)="userName.toggle($event)"></i>
        <span class="p-d-none p-d-md-none p-d-lg-inline-block"
          >Welcome, {{ displayName }}</span
        >
        <p-overlayPanel #userName styleClass="username-overlay">
          <ng-template pTemplate>
            Welcome,<br />
            , {{ displayName }}
          </ng-template>
        </p-overlayPanel>
      </div>

      <div class="portal">
        <button
          type="button"
          pButton
          icon="pi pi-cog"
          class="p-button-text portal-sm-button"
          [ariaLabel]="selectedDept || 'Department Settings'"
          (click)="portal.toggle($event)"
          pTooltip="{{ selectedDept }}"
          tooltipPosition="bottom"
        ></button>

        <button
          pButton
          [ariaLabel]="selDepartment?.departmentName"
          label="{{ selDepartment?.departmentName }}"
          icon="pi pi-cog"
          class="p-button-sm p-button-text portal-lg-button"
          (click)="portal.toggle($event)"
          [disabled]="portalItems.length <= 1"
        ></button>

        <p-menu #portal [popup]="true" [model]="portalItems"></p-menu>
      </div>
    </div>

    <div class="hamburger-menu">
      <button
        type="button"
        pButton
        aria-label="Show/Hide Menu"
        icon="pi pi-bars"
        class="p-button-text"
        (click)="menu.toggle($event)"
      ></button>
      <p-menu #menu [popup]="true" [model]="items"></p-menu>
    </div>
  </div>
</header>
